import anychart from 'anychart';
import {getTooltipContent} from "./customUtils";


class SeriesItemConfig {

    constructor(config) {
        this.config = config;
    }

    getName(){return this.config?.name ?? '';}

    getPlotType(){return this.config?.type ?? 'line';}

    getStroke(){
        return {
            color: this.config?.stroke,
            thickness: this.config?.thickness ?? 1
        }
    }

    prefix(){
        return this.config?.prefix ?? '';
    }
    postfix(){
        return this.config?.postfix ?? '';
    }

    precision(){
        return this.config?.precision ?? 2;
    }

    maybeApplyStyles(series){
        if (this.config.hasOwnProperty('fill') && this.getPlotType()!=='line') {
            series.fill(this.config.fill);
        }
        if (['rangeSplineArea', 'rangeArea'].includes(this.getPlotType())){
            series.highStroke(this.getStroke());
            series.lowStroke(this.getStroke());
        }
        series.stroke(this.getStroke());
    }

    styleValue(value){
        return `${this.prefix()}${value.toFixed(this.precision())}${this.postfix()}`;
    }
}


export const fillSeriesFromConfig = (config, plot, dataMapping, lastHoveredTimestamp, setLastHoveredTimestamp,
                                     setLastHoveredPoint, showSnapshotTooltip) => {
  const seriesConfig = new SeriesItemConfig(config);
  const plotType = seriesConfig.getPlotType()
  let series = plot[plotType](dataMapping);
  series.name(seriesConfig.getName());
  seriesConfig.maybeApplyStyles(series);

  // Check if the series has snapshot data to be displayed in the tooltip
  if (config.hasSnapshot) {
    series.tooltip().format(
        getTooltipContent({
            lastHoveredTimestamp, setLastHoveredTimestamp, setLastHoveredPoint, showSnapshotTooltip,
            precision: seriesConfig.precision(),
            seriesData: config.data,
        })); // Set the tooltip content using the closure
  }
  else {
    series.tooltip().format(function() {
        if (showSnapshotTooltip) {

            return showSnapshotTooltip ? `${this?.seriesName}: ${seriesConfig.styleValue(this?.value??0)}` : '';
        }
    });
  }
  return series;
};

/**
 * Handle the series data and configuration to create a data table and mapping for each series item added to a plot
 * @param data
 * @param config
 * @returns {{mapping: {x: number}, dataTable: *}}
 */
export const handleSeriesItem = (data, config)=>{
    const dataTable = anychart.data.table();
    let dataTableRows = data.map(item => [new Date(item[0]).getTime(), item[1]]);
    let mapping = { 'x': 0, [config?.valueKey??'value']: 1 };
    if (config.hasOwnProperty('extraFields')){
        config.extraFields.forEach((field, index)=>{
            mapping[field] = index+2;
            data.forEach((item, itemIndex)=>{
                dataTableRows[itemIndex].push(item[index+2]);
            })
        });
    }
    else if (config?.hasSnapshot===true){
        mapping.snapshot = 2;
    }
    dataTable.addData(dataTableRows);
    return {dataTable, mapping}
}